// src/pages/materials/MaterialsInout.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Card = ({ title, desc, onClick }) => (
  <button
    onClick={onClick}
    className="block w-full text-left border rounded-lg p-4 hover:bg-gray-50 active:bg-gray-100 transition-colors"
  >
    <div className="text-sm font-semibold text-gray-900">{title}</div>
    <div className="text-xs text-gray-500 mt-1">{desc}</div>
  </button>
);

export default function MaterialsInout() {
  const nav = useNavigate();
  const { id: projectId } = useParams();

  const goOfficial = (type) => {
    nav(`/project/${projectId}/materials/inout/new/`);
  };

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-4 border">
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0 flex-1">
              <h2 className="text-lg font-bold text-gray-900 truncate">
                입출고 문서 작성
              </h2>
              <p className="text-gray-500 text-xs mt-0.5">
                아래에서 작성할 문서를 선택하세요. 선택 시 공식 양식으로 바로 이동합니다.
              </p>
            </div>
            <button
              className="btn-basic-sm flex-shrink-0"
              onClick={() => nav(-1)}
            >
              뒤로
            </button>
          </div>
        </div>

        {/* 공식 규격 템플릿 직행 */}
        <div className="bg-white rounded-lg border overflow-hidden">
          <div className="border-b px-4 py-3 font-medium bg-gray-50">공식 규격 템플릿</div>
          <div className="grid gap-3 p-4">
            <Card
              title="입고서 (GR)"
              desc="자재 입고 공식 양식"
              onClick={() => goOfficial("GR")}
            />
            <Card
              title="출고서 (GI)"
              desc="자재 출고 공식 양식"
              onClick={() => goOfficial("GI")}
            />
          </div>
        </div>

        <div className="bg-white rounded-lg border p-4">
          <div className="text-xs font-medium text-gray-700 mb-2">도움말</div>
          <ul className="list-disc pl-5 text-xs text-gray-600 space-y-1">
            <li>모든 입출고 문서는 공식 규격 템플릿(모드=3)으로 생성합니다.</li>
            <li>사용자 템플릿이 필요하면 '문서 만들기'에서 진입하세요.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
